import React from 'react';
import { Box, Typography } from '@mui/material';
import Image from '../../Image/Image';

export const DEFAULT_CARD_MAX_WIDTH = 1113;

export const resolveLaunchPadHeroTitle = (title) =>
  Array.isArray(title) ? title.join('\n') : title;

const renderFeatureIcon = (icon, isDesktop) => {
  if (!icon) return null;

  if (typeof icon === 'string') {
    return (
      <Image
        width={28}
        height={28}
        src={icon}
        alt="Feature icon"
        aria-hidden="true"
        sx={{
          width: isDesktop ? '28px' : { xs: '16px', md: '18px' },
          height: isDesktop ? '28px' : { xs: '16px', md: '18px' },
          display: 'block',
          objectFit: 'contain',
        }}
      />
    );
  }

  return icon;
};

export const LaunchPadHeroFeature = ({ icon, label, isDesktop }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '8px',
      width: isDesktop ? 'max-content' : '100%',
      maxWidth: 'none',
      minWidth: 0,
      flex: isDesktop ? '0 0 auto' : '1 1 0%',
    }}
  >
    <Box
      aria-hidden="true"
      sx={{
        width: isDesktop ? '48px' : { xs: '32px', md: '40px' },
        height: isDesktop ? '48px' : { xs: '32px', md: '40px' },
        borderRadius: isDesktop ? '12px' : { xs: '10px', md: '12px' },
        backgroundColor: '#C7CA00',
        color: '#162F3B',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& svg': {
          fontSize: isDesktop ? '1.75rem' : { xs: '1rem', md: '1.15rem' },
        },
      }}
    >
      {renderFeatureIcon(icon, isDesktop)}
    </Box>

    <Typography
      sx={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: isDesktop ? 700 : 700,
        fontSize: isDesktop ? '0.875rem' : { xs: '0.875rem', md: '1rem' },
        lineHeight: isDesktop ? '1.25rem' : { xs: '1rem', md: '1.15rem' },
        letterSpacing: isDesktop ? '-0.002em' : '-0.02em',
        color: '#162F3B',
        textAlign: 'left',
        width: isDesktop ? 'auto' : '100%',
        maxWidth: 'none',
        minWidth: 0,
        whiteSpace: isDesktop ? 'nowrap' : 'normal',
        flex: isDesktop ? '0 0 auto' : '1 1 auto',
        flexShrink: 1,
      }}
    >
      {label}
    </Typography>
  </Box>
);
